<template>
  <div v-if="groupInfo.type">
    <div
      v-if="
        ($auth.policies['view-tuition-fee-group-list'] && groupInfo.type === 'normal') ||
        ($auth.policies['view-priority-group-list'] && groupInfo.type === 'priority')
      "
      class="pt-4"
    >
      <div class="px-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            v-if="groupInfo.type === 'normal'"
            :headline="groupInfo.title"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: `Nhóm đối tượng ${getTypeGroup(groupInfo.type)}`, href: '../../tuition-fee-group' },
              { text: groupInfo.title },
            ]"
          />
          <Breadcrumbs
            v-if="groupInfo.type === 'priority'"
            :headline="groupInfo.title"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: `Nhóm đối tượng ${getTypeGroup(groupInfo.type)}`, href: '../../tuition-fee-priority-group' },
              { text: groupInfo.title },
            ]"
          />
        </div>
      </div>
      <v-card outlined class="pa-6 mx-4 my-6 elevation-0">
        <DetailInfoGroup />
      </v-card>
      <div class="mx-4">
        <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
          <v-tab v-for="item in getTab(groupInfo.type)" :key="item" class="tab-default">
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-card outlined class="elevation-0">
          <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
              <ListActions />
              <v-card outlined sm="12" class="mx-6">
                <ListStudents />
              </v-card>
              <v-col sm="12" class="d-flex justify-center">
                <v-btn
                  v-if="
                    groupInfo.category === 'custom' &&
                    (($auth.policies['delete-tuition-fee-group'] && groupInfo.type === 'normal') ||
                      ($auth.policies['delete-priority-group'] && groupInfo.type === 'priority'))
                  "
                  outlined
                  color="error"
                  class="mx-1 mt-2"
                  @click="deleteThisGroup"
                >
                  Xoá nhóm đối tượng
                </v-btn>
              </v-col>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card outlined sm="12" class="ma-6">
                <ListGroupHeadFee />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import DetailInfoGroup from '@/modules/tuitionFee/detail-group/DetailInfoGroup'
import ListActions from '@/modules/tuitionFee/detail-group/ListActions'
import ListStudents from '@/modules/tuitionFee/detail-group/ListStudents'
import ListGroupHeadFee from '@/modules/tuitionFee/detail-group/ListGroupHeadFee'
import Page403 from '@/views/Page403.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data() {
    return {
      tab: null,
    }
  },
  async created() {
    await this.resetData()
    await this.fetchOne(this.$route.params.id)
    await this.getTotalStudent(this.groupInfo)
  },
  components: {
    ListStudents,
    ListGroupHeadFee,
    Breadcrumbs,
    DetailInfoGroup,
    ListActions,
    Page403,
  },
  computed: {
    ...mapGetters('tuitionFeeGroup', ['groupInfo', 'typeGroup']),
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['fetchOne', 'deleteGroup']),
    ...mapMutations('tuitionFeeGroup', ['setTypeGroup']),
    ...mapActions('tuitionFeeGroupStudent', [
      'searchStudentsTuitionFee',
      'searchStudentsDefault',
      'requestPageSettings',
      'resetData',
    ]),
    ...mapActions('tuitionFeeGroupStudent', ['getTotalStudent', 'requestPageSettings']),
    async deleteThisGroup() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa nhóm đối tượng?',
        text: '<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá nhóm đối tượng?</div>',
        okText: 'Xóa',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            await this.deleteGroup(this.$route.params.id)
            this.$alert.deleteSuccess('nhóm đối tượng')
            if (this.groupInfo.type === 'normal') {
              this.$router.push({ path: '../../tuition-fee-group' })
            } else {
              this.$router.push({ path: '../../tuition-fee-priority-group' })
            }
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: 'Không thể xóa nhóm đối tượng. Vui lòng thử lại!',
            })
          }
        },
      })
    },
    getTypeGroup(type) {
      switch (type) {
        case 'normal': {
          return 'chịu phí'
        }
        case 'priority': {
          return 'giảm trừ'
        }
      }
    },
    getTab(type) {
      switch (type) {
        case 'normal': {
          return ['Danh sách học viên', 'Khoản phí đã gán']
        }
        case 'priority': {
          return ['Danh sách học viên', 'Khoản giảm trừ']
        }
      }
    },
  },
}
</script>
